module.exports = __webpack_public_path__ + "static/media/pdf-icon.3a3b4990.svg";